import Vue from 'vue'

// User login
const login = credentials => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/login',
			auth: credentials
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getPO = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-order/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getPODetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-order/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Save new PI
const createPI = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getPI = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getPIDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice-item/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getBrand = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/brand/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const searchProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/list-advance',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getWarehouse = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get list of POs
const getDP = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/direct-purchase/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Save Direct Purchase
const saveDP = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/direct-purchase/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get DP Detail
const getDPDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/direct-purchase/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get DP Detail
const getProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse-product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Update product
const updateProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/warehouse-product/update',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get product return list
const getReturnList = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get Return Details
const getReturnDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Close Return
const closeReturn = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/close',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})

			console.log(err.response)
		})
}

// Get PO Details
const getPiItemDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice-item/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of shops
const getShops = () => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop/list',
			data: {
				limit: 30,
				status: true
			}
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Save product transfer
const saveProductTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse/product/transfer',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get product transfer
const getProductTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse/product/transfer/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Save stock transfer
const saveStockTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse-stock-transfer/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get stock transfer
const getStockTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse-stock-transfer',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

export default {
	login: login,
	getPO: getPO,
	getPODetail: getPODetail,
	createPI: createPI,
	getPI: getPI,
	getBrand: getBrand,
	getPIDetail: getPIDetail,
	getWarehouse: getWarehouse,
	searchProduct: searchProduct,
	getDP: getDP,
	saveDP: saveDP,
	getDPDetail: getDPDetail,
	getProducts: getProducts,
	updateProduct: updateProduct,
	getReturnList: getReturnList,
	getReturnDetail: getReturnDetail,
	closeReturn: closeReturn,
	getPiItemDetail: getPiItemDetail,
	getShops: getShops,
	saveProductTransfer: saveProductTransfer,
	getProductTransfer: getProductTransfer,
	saveStockTransfer: saveStockTransfer,
	getStockTransfer: getStockTransfer
}
